import { TRADE_OVERLAY_TYPE } from '@/constants/trade';
import { useTradeStoreTransformed } from '@/features/trade/hooks';
import { useTradeStore } from '@/features/trade/store';
import classNames from 'classnames';
import React, { useCallback } from 'react';
import { Button } from '../Button';
import { Tooltip } from '../ToolTip';
import './index.less';

interface LeverageSelectorProps {
  className?: string;
  disabled?: boolean;
  onLeverageChange?: (leverage: number) => void;
}

export const LeverageSelector: React.FC<LeverageSelectorProps> = ({ disabled = false, className }) => {
  const { setShowTradeAreaOverlay } = useTradeStore();
  const { leverage } = useTradeStoreTransformed();
  const handleLeverageClick = useCallback(() => {
    setShowTradeAreaOverlay(TRADE_OVERLAY_TYPE.LEVERAGE);
  }, [setShowTradeAreaOverlay]);

  return (
    <div className={classNames('leverage-selector', className)}>
      <Button className="leverage-button" onClick={handleLeverageClick} disabled={disabled}>
        {leverage}x
      </Button>
      <Tooltip
        title="Isolated Margin Mode: Manage your risk on individual positions by restricting the amount of margin allocated to each. If the margin of a position falls below the required Maintenance Margin, the position will be liquidated. Margin can be added or removed to positions using this mode."
        placement="top">
        <Button className="isolated-button" disabled>
          Isolated
        </Button>
      </Tooltip>
    </div>
  );
};

export default LeverageSelector;
